const getRoot = () => {
  switch (window.location.hostname) {
    case 'puma-devtest.utswmed.org':
      return 'https://devtest.utswmed.org';
    case 'puma-staging.utswmed.org':
      return 'https://staging.utswmed.org';
    case 'puma.utswmed.org':
      return 'https://utswmed.org';
    default:
      return 'http://localhost:8010';
  }
};

export const API_ROOT = getRoot();
export const SECRET_KEY = 'l124sdfkajsdf98ujdkh';



// WEBPACK FOOTER //
// ./src/settings.jsx